import { render } from "./WhyChooseUsSection.vue?vue&type=template&id=8666af30&scoped=true"
import script from "./WhyChooseUsSection.vue?vue&type=script&lang=js"
export * from "./WhyChooseUsSection.vue?vue&type=script&lang=js"

import "./WhyChooseUsSection.vue?vue&type=style&index=0&id=8666af30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8666af30"]])

export default __exports__